<template>
    <div class="media">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'Media',
        props: {
            id: String,
            configuration: Object
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .media
    {
        padding: 0 20px;

        img
        {
            overflow: hidden;
        }
    }
</style>
